/**
 * @fileoverview Common base functionality for AI API clients.
 *
 * This module serves as the main entry point for the base client functionality,
 * providing a unified interface for client implementation, HTTP requests,
 * response processing, and model detection.
 */

export * from './abstractClient';
export * from './httpClient';
export * from './modelDetection';
export * from './responseProcessor';
